import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Button from './Button';
import Glyph from '../Glyph/Glyph';
import './Button.scss';

const GlyphedButton = ({className, disabled, floated, glyph, glyphComponent, id, label, large, name, onClick, title, type="button"}) => {
    const buttonClassValues = classNames(
        "btn icon-btn btn-base",
        {"btn-lg": large},
        {"floated-right": floated==="right"},
        {"floated-left": floated==="left"},
        className
    );

    return(
        <Button
            className={buttonClassValues}
            disabled={disabled}
            htmlId={id}
            name={name}
            onClick={onClick}
            title={title}
            type={type}>
            {glyphComponent &&
                glyphComponent}
            {glyph && <Glyph
                additionalClass="btn-glyphicon"
                glyph={glyph}/>}
            {label}
        </Button>
    );
};

GlyphedButton.propTypes = {
    //Class which will be applied to button.
    className: PropTypes.string,
    //Should button be disabled.
    disabled: PropTypes.bool,
    //Allign button to left or right.
    floated: PropTypes.oneOf(["left", "right"]),
    //Glyph.
    glyph: PropTypes.string,
    //Glyph component.
    glyphComponent: PropTypes.node,
    //Html id attribute.
    id: PropTypes.string,
    //Button text.
    label: PropTypes.string,
    //Display large button.
    large: PropTypes.bool,
    //Component name.
    name:PropTypes.string,
    //On click function.
    onClick: PropTypes.func,
    //Tool tip text
    title: PropTypes.string,
    //Button type.
    type: PropTypes.string,
};

export default GlyphedButton;



// WEBPACK FOOTER //
// ./src/components/base/Button/GlyphedButton.js